import { GetRequestOptions } from "./grunt";

const getPth=process.env.REACT_APP_GRUNT_API+"/util";
const StatusOk={status:200};



const getZivBrRegex=async()=>{
    let _pth=getPth+"/zivbrregex";
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}



const getStanje01=async({_datod=new Date().toISOString().split('T')[0],_datdo=new Date().toISOString().split('T')[0],_type='normal'})=>{
    let _pth=getPth+`/stanje01?datod=${_datod}&datdo=${_datdo}&type=${_type}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        let res;
        if (_type==='normal') {//samo podaci
            res=await r.json();    
        } else {//pdf ili excel izvj
            res=await r.arrayBuffer();
        }
        
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getStanjePoKnjigama=async({_datod=new Date().toISOString().split('T')[0],_datdo=new Date().toISOString().split('T')[0],_type='normal'})=>{
    let _pth=getPth+`/stanjepoknjigama?datod=${_datod}&datdo=${_datdo}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        let res;
       
            res=await r.json();    
       
        
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getStanjePoPosjednicima=async({_datod=new Date().toISOString().split('T')[0],_datdo=new Date().toISOString().split('T')[0],_type='normal'})=>{
    let _pth=getPth+`/stanjepoposjednicima?datod=${_datod}&datdo=${_datdo}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        let res;
       
            res=await r.json();    
       
        
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getEnvironment=async ()=>{
    let _pth=getPth+`/environment`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        StatusOk.res=res;
        return StatusOk;
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

// api/exportApi.js
const exportData_MigracijeKnjige=async(knjigaId) =>{
    
    const res = await fetch(getPth+`/exportdata?knjigaid=${encodeURIComponent(knjigaId)}`, GetRequestOptions("GET"));

  // Greška PRIJE streama → server je poslao čisti JSON (400/404/500)
  if (!res.ok) {
    let msg = 'Eksport nije uspio';
    try {
      const err = await res.json();
      if (err?.message) msg = err.message;
    } catch {
      /* nije JSON — ostavi default */
    }
    throw new Error(msg);
  }

  // Greška USRED streama → res.ok je true, ali blob() pukne (konekcija prekinuta)
  const blob = await res.blob();

  // Naziv iz Content-Disposition, fallback ako fali
  const filename =
    parseFilename(res.headers.get('Content-Disposition')) ||
    `grunt-export-knjiga-${knjigaId}.csv`;

  await triggerDownload(blob, filename);
}


const parseFilename=(disposition) =>{
  if (!disposition) return null;
  const m = /filename="?([^"]+)"?/.exec(disposition);
  return m ? m[1] : null;
}

const triggerDownload= async (blob, filename) =>{
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export {getZivBrRegex,getStanje01,getEnvironment,getStanjePoKnjigama,getStanjePoPosjednicima,exportData_MigracijeKnjige};